import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import Platform from "@/config/platform";
import { md5, YMPush } from "@/uitls/uitls";
import { pickQueryParam, nativeToLogin } from "@/uitls/native";
import { Toast } from "vant";
import {
  SetPassword,
  changePassword,
  getPhoneCode,
  phoneChangePassword,
  forgetPasswordByEmail
} from "@/api/im";

import { usePiniaState } from "@/store/userPinia";
import { storeToRefs } from "pinia";
import { useI18n } from "vue-i18n";
import EventBus from "@/uitls/EventBus";

export default /*#__PURE__*/_defineComponent({
  name: 'Changepwd',
  setup(__props, { expose }) {
  expose();

const { t } = useI18n();
const piniaStore = usePiniaState();

const { user, isYk } = storeToRefs(piniaStore);
const { toLogin } = piniaStore;

const router = useRouter();
const route = useRoute();
let password = ref("");
let password2 = ref("");
let oldPassword = ref("");
// let isPassword = route.query.isps == "1" ? true : false;
let isPassword = true;
const jumpType = ref("0");
let verifycode = "";
let email = "";

onMounted(() => {

  const raw = pickQueryParam(route, "jumpType");
  verifycode = pickQueryParam(route, "verifycode");
  email = pickQueryParam(route, "email");

  if (raw == undefined || raw == "") {
    jumpType.value = "0";
  } else {
    jumpType.value = raw;
  }

  toLogin();
  YMPush("MAIN", "SetPwd");
});

const onSubmit = async (values) => {
  console.log('on submit', values);

  if (oldPassword.value == password.value) {
    Toast.fail('passwordIsSame');
  } else {
    const oldpasswd = md5(oldPassword.value);
    const newpasswd = md5(password.value);

    
    if (jumpType.value == "1") { //重置密码
      let result:any = await forgetPasswordByEmail({
          verifycode: verifycode,
          email: email,
          newpasswd: newpasswd
      });
      if (result.ret == 0) {
        Toast.success(t("me.chgangsu"));
        router.push("/");
        nativeToLogin(router);
      } else {
        Toast.fail(result.msg);
      }

    } else { //修改密码

      let result: any = await changePassword({
        oldpasswd: oldpasswd,
        newpasswd: newpasswd,
      });
      console.log(result);
      if (result.ret == 0) {
        Toast.success(t("me.chgangsu"));
        router.back();
      } else {
        Toast.fail(result.msg);
      }
    }


  }
};

const pattern = /^[A-Za-z0-9!@#\$%\^&\*\(\)_\+\-=\[\]\{\};:'",.<>\/?\\|`~]{6,20}$/;


const __returned__ = { t, piniaStore, user, isYk, toLogin, router, route, password, password2, oldPassword, isPassword, jumpType, verifycode, email, onSubmit, pattern }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})